module.exports = __webpack_public_path__ + "static/media/information.b9044e3a.svg";